import { observer } from 'mobx-react'
import React from 'react'
import { Timeline } from 'react-twitter-widgets'
import DashboardVM from '../DashboardVM'
import { Icon } from 'ui-framework'
const placeholder = (
  <Icon
    name="twitter"
    className="lobby__twitter-placeholder"
    color="var(--placeholder-bg)"
    size={64}
  />
)
// Keep the Twitter in its own component for performance optimizations, due to widget width bug

export function Twitter({ vm }: { vm: DashboardVM }) {
  const { uiStore } = vm.rootStore
  const { width } = uiStore.media.viewPort.size
  // fix twitter widget growing length
  const maxWidth = width - (uiStore.media.mdPlusScreen ? 40 : 32)
  const twitterHeight = uiStore.media.xlScreen ? 443 : 364

  return (
    <div className="lobby__twitter panel--simple" style={{ maxWidth }}>
      {placeholder}
      <Timeline
        dataSource={{ sourceType: 'profile', screenName: 'OokiTrade' }}
        options={{ width: '100%', height: twitterHeight, theme: uiStore.theme }}
      />
    </div>
  )
}

export default observer(Twitter)
